import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../services/useAuth';
import { mapFirebaseSignInError } from '../../services/firebaseAuthErrors';
import { SiteLink, useRouter } from '../../../components';

export function Login(props) {
  const { returnUrl: returnUrlProp } = props;
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [pending, setPending] = React.useState(false);
  const auth = useAuth();
  const router = useRouter();
  const location = useLocation();

  function submit(e) {
    e.preventDefault();
    e.stopPropagation();
    const trimmedEmail = (username || '').trim();
    if (!trimmedEmail) {
      setError('Please enter your email address.');
      return;
    }
    if (!password) {
      setError('Please enter your password.');
      return;
    }
    setError('');
    setPending(true);

    auth
      .signin(trimmedEmail, password)
      .then(() => {
        setPending(false);
        setError('');
        const fromQuery = new URLSearchParams(location.search || '').get('returnUrl');
        const returnUrl = returnUrlProp != null ? returnUrlProp : fromQuery;
        const safeUrl = returnUrl && returnUrl.startsWith('/') && !returnUrl.startsWith('//') ? returnUrl : '/members-area';
        router.push(safeUrl);
      })
      .catch((err) => {
        setPending(false);
        setError(mapFirebaseSignInError(err));
      });
  }

  return (
    <div className="sign-in auth-panel auth-panel--centered" style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 0' }}>
      <div className="auth-panel__inner">
        <div className="auth-panel__card" style={{ background: 'white', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' }}>
          <h1 className="h4 mb-1">Sign In</h1>
          <p className="text-muted mb-4" style={{ fontSize: '0.95rem' }}>
            Sign in to your account.
          </p>
          <form method="POST" noValidate="" onSubmit={submit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                className="form-control"
                name="email"
                required
                autoComplete="email"
                autoFocus
                value={username}
                onChange={e => setUsername(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                className="form-control"
                name="password"
                required
                autoComplete="current-password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
            <div className="form-group m-0">
              <button type="submit" disabled={pending} className="btn btn-primary btn-block">
                {pending && <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                <span>Sign In</span>
              </button>
            </div>
            {error && (
              <div
                role="alert"
                className="text-danger small mt-2"
                style={{ lineHeight: 1.45 }}
              >
                {error}
              </div>
            )}
            <div className="text-center mt-3">
              <SiteLink to="/forgot-password">Forgot Password?</SiteLink>
            </div>
            <div className="text-center mt-2">
              Not a member?{' '}
              {(() => {
                const fromQuery = new URLSearchParams(location.search || '').get('returnUrl');
                const returnUrl = returnUrlProp != null ? returnUrlProp : fromQuery;
                if (returnUrl) {
                  try {
                    sessionStorage.setItem('signupReturnUrl', returnUrl);
                  } catch (_) {}
                  return (
                    <Link to={{ pathname: '/sign-up', search: `?returnUrl=${encodeURIComponent(returnUrl)}`, state: { returnUrl } }}>
                      Register
                    </Link>
                  );
                }
                return <SiteLink to="/sign-up">Register</SiteLink>;
              })()}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
